<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 850px;">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">{{ formTitle }}</p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form" :loading="sending">
            <form-group
              name="bank_number"
              horizontal
              :label="$t('attributes.bank_number')"
              label-position="on-border"
            >
              <b-input
                v-if="mode === 'create'"
                v-model="form.bank_number"
                type="text"
                expanded
              />
              <span v-else>{{ form.bank_number }}</span>
            </form-group>
            <form-group
              name="bank_name"
              horizontal
              :label="$t('attributes.name')"
              label-position="on-border"
            >
              <b-input v-model="form.bank_name" type="text" expanded />
            </form-group>
            <form-group
              name="bank_short_name"
              horizontal
              :label="$t('attributes.short_name')"
              label-position="on-border"
            >
              <b-input v-model="form.bank_short_name" type="text" expanded />
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              mode === 'create'
                ? $t('attributes.add')
                : $t('attributes.update_data')
            }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'BankDetail',
  props: {
    data: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formTitle: this.mode === 'create' ? '新增銀行資料' : '修改銀行資料',
      sending: false,

      form: this.extractFormValues(this.data)
    }
  },
  validations: {
    form: {
      id: {},
      bank_name: { required, maxLength: maxLength(30) },
      bank_number: { required, maxLength: maxLength(5) },
      bank_short_name: { maxLength: maxLength(30) }
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        bank_name: data.bank_name,
        bank_number: data.bank_number,
        bank_short_name: data.bank_short_name
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('send', this.form)
    }
  }
}
</script>
